var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoContainer",staticClass:"shadow-lg mx-auto max-w-full size"},[_c('video',{ref:"videoPlayer",staticClass:"w-full video-ratio",attrs:{"id":"video","crossorigin":"anonymous","playsinline":"","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }